import { useRadio } from '@chakra-ui/react';
import { Box, RadioProps, Text } from '@cmpsr/components';

type QuestionOptionCardProps = {
  componentProps?: RadioProps;
  label: string;
  description?: string;
};

export default function QuestionOptionCard(props: QuestionOptionCardProps) {
  const { getInputProps, getRadioProps } = useRadio(props.componentProps);

  return (
    <Box as="label" height="full">
      <input {...getInputProps()} />
      <Box
        {...getRadioProps()}
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        gap={1}
        flexGrow={1}
        width="full"
        height="full"
        minHeight="110px"
        background="background-action-default"
        border="1px solid var(--chakra-colors-ui-element-outline-default)"
        borderRadius="radii-4"
        cursor="pointer"
        _focus={{
          boxShadow: 'var(--chakra-shadows-elevation-interactive)',
        }}
        _checked={{
          borderColor: 'secondary-default',
          boxShadow:
            'var(--chakra-shadows-elevation-interactive), inset 0px 0px 0px 1px var(--chakra-colors-secondary-default)',
        }}
        px={5}
        py={10}
      >
        <Text variant="text-body-regular" color="text-primary">
          {props.label}
        </Text>
        {props.description ? (
          <Text as="span" variant="text-body-meta-regular" color="text-secondary">
            {props.description}
          </Text>
        ) : null}
      </Box>
    </Box>
  );
}
